import { get, post } from 'services/api';
import { FolderId } from 'modules/domains/foldering';

export const COPY_CAMPAIGN_URL = '/campaigns/clone';
export const ARCHIVE_CAMPAIGN_URL = '/campaigns/archive';
export const UNARCHIVE_CAMPAIGN_URL = '/campaigns/unarchive';
export const CAMPAIGN_DATA_URL = '/campaigns/getCampaignsData';
export const CAMPAIGN_METRICS_URL = '/i/campaigns/getMetrics';

export type HighLevelMetricValue = {
  key: string;
  value: string;
};

export type HighLevelMetrics = {
  clickRate: HighLevelMetricValue;
  openRate: HighLevelMetricValue;
  totalBounces: HighLevelMetricValue;
  totalClicks: HighLevelMetricValue;
  totalDelivered: HighLevelMetricValue;
  totalRetrieved: HighLevelMetricValue;
  totalSent: HighLevelMetricValue;
  uniqueOpens: HighLevelMetricValue;
  unsubscribeRate: HighLevelMetricValue;
};

// from scala models.analytics.HighLevelMetric
export const highLevelMetrics: HighLevelMetrics = {
  clickRate: {
    key: 'ClickRate',
    value: 'Click Rate',
  },
  openRate: {
    key: 'UniqueOpenRate',
    value: 'Unique Open Rate',
  },
  totalBounces: {
    key: 'TotalBounces',
    value: 'Total Bounces',
  },
  totalClicks: {
    key: 'TotalClicks',
    value: 'Total Clicks',
  },
  totalDelivered: {
    key: 'TotalDelivered',
    value: 'Total Delivered',
  },
  totalRetrieved: {
    key: 'TotalRetrieved',
    value: 'Total Retrieved',
  },
  totalSent: {
    key: 'TotalSent',
    value: 'Total Sent',
  },
  uniqueOpens: {
    key: 'UniqueOpens',
    value: 'Unique Opens',
  },
  unsubscribeRate: {
    key: 'UnsubscribeRate',
    value: 'Unsubscribe Rate',
  },
};

export const copyCampaign = (campaignId: number, destinationFolderId: FolderId | null) =>
  post(COPY_CAMPAIGN_URL, { campaignId, destinationFolderId });

export const archiveCampaigns = (campaignIds: number[]) =>
  post(ARCHIVE_CAMPAIGN_URL, { campaignIds });

export const unarchiveCampaigns = (campaignIds: number[]) =>
  post(UNARCHIVE_CAMPAIGN_URL, { campaignIds });

export const exportCampaignToCSV = (campaignIds: number[]) =>
  post(CAMPAIGN_DATA_URL, { campaignIds });

export const getCampaignMetrics = (campaignIds: number[]) => {
  const selectedMetrics = [
    highLevelMetrics.totalClicks.key,
    highLevelMetrics.totalDelivered.key,
    highLevelMetrics.totalRetrieved.key,
    highLevelMetrics.totalSent.key,
    highLevelMetrics.clickRate.key,
    highLevelMetrics.openRate.key,
  ];
  return get(
    `${CAMPAIGN_METRICS_URL}?${campaignIds
      .map((id) => `campaignIds=${id.toString()}`)
      .join('&')}&${selectedMetrics
      .map((metric) => `selectedHighLevelMetrics=${metric}`)
      .join('&')}`,
  );
};
